import {useEffect, useRef, useState} from 'react'
import deleteIcon from '../../../../media/shared-access/ic-delete.svg'
import backIcon from '../../../../media/shared-access/ic-back.svg'
import nextIcon from '../../../../media/shared-access/ic-next.svg'
import prevIcon from '../../../../media/shared-access/ic-prev.svg'
import starIcon from '../../../../media/shared-access/ic-star.svg'
import starActiveIcon from '../../../../media/shared-access/ic-star-active.svg'
import DropdownIcon from '../../../../media/shared-access/ic-dropdown.svg'
import Pdf from '../../../../media/images/pdf-img.svg'
import Doc from '../../../../media/images/doc-img.svg'
import {useIntl} from 'react-intl'
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import EmailForm from './reply-email'
import Attachments from './attachments'
import '../style/inboxdetails.scss'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import {deleteEmails, getAllEmail, getEmail, markedStarred} from '../core/_requests'
import {DateTime} from 'luxon'
import {InboxQuill} from './InboxQuill'
import {Form, Formik} from 'formik'
import {ConfirmationModal} from './ConfirmationModal'
import Skeleton from 'react-loading-skeleton'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export const InboxDetails = ({
  composeEmailSchema,
  initialValues,
  submitStep,
  userInfo,
  setEmailStatus,
  emailStatus,
  setStarredEmails,
  starredEmails,
  getAllMails,
  emails,
}: any) => {
  const {formatMessage} = useIntl()
  const [searchParams] = useSearchParams()
  const emailId = searchParams.get('id')
  const {companyId, currentUser} = useAuth()
  const [threadEmails, setThreadEmails] = useState<any[]>([])
  const [isFirstExpanded] = useState(true)
  const firstContentRef = useRef<HTMLDivElement>(null)
  const [firstMaxHeight, setFirstMaxHeight] = useState('0px')
  const [isExpanded] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null) // Specify the type of the ref
  const [maxHeight, setMaxHeight] = useState('0px')
  const [threadId, setThreadId] = useState<string>()
  const [status, setStatus] = useState('')
  const [search] = useState<string>('')
  const [expandedIndex, setExpandedIndex] = useState(0) // Track which email is expanded
  const contentRefs = useRef<(HTMLDivElement | null)[]>([])
  const [quillText, setQuillText] = useState('')
  const [isStarred, setIsStarred] = useState<boolean>()
  const [selectedEmails, setSelectedEmails] = useState<string[]>([])
  const id = searchParams.get('id')
  const getStatus = searchParams.get('status')
  const navigate = useNavigate()
  const location = useLocation()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [emailLoading, setEmailLoading] = useState<boolean>(false)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [showToMeMenu, setShowToMeMenu] = useState(false)
  const [showEmail, setShowEmail] = useState<any>()
  const [showToMeEmail, setShowToMeEmail] = useState<any>()

  const [isForwardEmailClick, setIsForwardEmailClick] = useState<boolean>(false)
  console.log(isStarred)

  useEffect(() => {
    const index = emails.findIndex((email: any) => email.emailMessageId === id)
    if (index !== -1) {
      setCurrentIndex(index)
    }
  }, [id, emails])

  const goToPreviousEmail = () => {
    if (currentIndex > 0) {
      const prevEmail = emails[currentIndex - 1]
      setCurrentIndex(currentIndex - 1)
      navigate(
        `/shared-access?tab=inbox&status=${emailStatus.toLowerCase()}&id=${
          prevEmail.emailMessageId
        }`
      )
    }
  }
  const goToNextEmail = () => {
    if (currentIndex < emails.length - 1) {
      const nextEmail = emails[currentIndex + 1]
      setCurrentIndex(currentIndex + 1)
      navigate(
        `/shared-access?tab=inbox&status=${emailStatus.toLowerCase()}&id=${
          nextEmail.emailMessageId
        }`
      )
    }
  }
  const goBack = () => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.has('id')) {
      searchParams.delete('id')
    }
    searchParams.set('status', emailStatus.toLowerCase())
    navigate(`${location.pathname}?${searchParams.toString()}`)
  }

  console.log(maxHeight)
  console.log(firstMaxHeight)

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`)
    }
  }, [isExpanded])

  useEffect(() => {
    if (firstContentRef.current) {
      setFirstMaxHeight(`${firstContentRef.current.scrollHeight}px`)
    }
  }, [isFirstExpanded])

  const getMail = async () => {
    // if (emailStatus.toLowerCase() === 'trash') {
    //   setEmailLoading(false)
    //   goBack()
    //   toast.error(formatMessage({id: 'This email is deleted'}))
    // }
    setEmailLoading(true)
    try {
      const {
        data: {success, error, data},
      } = await getEmail(companyId!, emailId!, emailStatus)
      if (success) {
        console.log(data, ' data')
        setThreadId(data.providerThreadId)
        setIsStarred(data.starred)
      } else {
        toast.error(formatMessage({id: error}))
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (emailId) {
      getMail()
    }
  }, [emailId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setExpandedIndex(0)
  }, [threadEmails]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (id) {
      setSelectedEmails((prevEmails) => [...prevEmails, id])
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps
  const handleEmailToggle = (index: number) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? -1 : index)) // Toggle expansion
  }

  const getAllThreadMails = async () => {
    // setThreadLoading(true)
    console.log(emailStatus, ' ststs')
    try {
      const {
        data: {success, error, data},
      } = await getAllEmail(companyId!, 1, 20, status, search, 'createdAt', 'ASC', threadId)
      if (success) {
        setThreadEmails(data.emails)
        const initialStarredEmails = data.emails.reduce(
          (acc: {[key: string]: boolean}, email: any) => {
            acc[email.emailMessageId] = email.starred // Assuming `isStarred` indicates if an email is starred
            return acc
          },
          {}
        )
        setStarredEmails(initialStarredEmails)
      } else {
        toast.error(formatMessage({id: error}))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setEmailLoading(false)
    }
  }

  useEffect(() => {
    if (threadId) {
      getAllThreadMails()
    }
  }, [threadId]) // eslint-disable-line

  useEffect(() => {
    if (emailStatus.toLowerCase() === 'trash') {
      setStatus('TRASH')
    }
  }, [emailStatus])

  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const formatTime = (time: string) => {
    const dateTime = DateTime.fromISO(time)
    const now = DateTime.now()

    if (dateTime.hasSame(now, 'day')) {
      return dateTime.toFormat('h:mm a') // Format as '8:30 PM' or '8:30 AM'
    } else if (dateTime.hasSame(now.minus({days: 1}), 'day')) {
      return 'Yesterday'
    } else {
      const diffInDays = Math.floor(now.diff(dateTime, 'days').days)

      if (diffInDays < 30) {
        return `${diffInDays} days ago`
      } else {
        const diffInMonths = Math.floor(now.diff(dateTime, 'months').months)
        return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`
      }
    }
  }

  const markedStarAndRead = async (payload: any) => {
    try {
      console.log(payload, ' payload star')
      console.log(emailId, ' emailid')
      const {
        data: {success, error, data},
      } = await markedStarred(companyId!, emailId!, payload)
      if (success) {
        console.log(data, ' marked')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailStarredSuccessful,
            action: 'normal',
            metadata: {
              email_id: emailId,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: error}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailStarredFailed,
            action: 'normal',
            metadata: {
              email_id: emailId,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: error,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailStarredFailed,
          action: 'normal',
          metadata: {
            email_id: emailId,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  const markedStar = (emailId: string) => {
    const isStarred = starredEmails[emailId] || false

    // Toggle the starred status
    setStarredEmails((prev: any) => ({
      ...prev,
      [emailId]: !isStarred,
    }))
    const payload = {starred: !isStarred}
    markedStarAndRead(payload)
  }

  const deleteMails = async () => {
    setIsDeleting(true)
    try {
      let payload = {
        isDraft: getStatus === 'draft',
        ids: selectedEmails,
      }
      const {
        data: {success, error, data},
      } = await deleteEmails(companyId!, payload)
      if (success) {
        console.log(data, ' deleted')
        getAllMails()
        setModalOpen(false)
        setSelectedEmails([])
        toast.success(formatMessage({id: 'Email deleted successfully'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeleteSuccessful,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
        navigate(`${location.pathname}?tab=inbox&status=inbox`)
      } else {
        toast.error(formatMessage({id: error}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeleteFailed,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: error,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailDeleteFailed,
          action: 'normal',
          metadata: {
            email_ids: selectedEmails,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <>
      <div className='card'>
        <div className='card-header align-items-center' style={{padding: '14px !important'}}>
          {emailLoading ? (
            <div className='d-flex gap-2'>
              <div>
                <Skeleton
                  width={40}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div>
                <Skeleton
                  width={40}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          ) : (
            <div className='d-flex'>
              <div
                className='btn btn-sm btn-icon btn-clear btn-active-light-primary me-3'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                title='Back'
                onClick={() => goBack()}
              >
                <img src={backIcon} alt='' className='inbox-prev-next-logo' />
              </div>

              <div
                className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2 '
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                title='Archive'
                onClick={() => setModalOpen(true)}
              >
                <img src={deleteIcon} alt='' className='inbox-prev-next-logo' />
              </div>
            </div>
          )}

          {emailLoading ? (
            <div className='d-flex align-items-center gap-2'>
              <div>
                <Skeleton
                  width={60}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div>
                <Skeleton
                  width={40}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div>
                <Skeleton
                  width={40}
                  height={40}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          ) : (
            <div className='d-flex align-items-center'>
              <span className='fw-semibold text-muted me-2'>
                {currentIndex + 1} of {emails.length}
              </span>
              <div
                className={`btn btn-sm btn-icon btn-light btn-active-light-primary me-3 ${
                  currentIndex === 0 ? 'disabled-button' : ''
                }`}
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                title='Previous message'
                onClick={() => {
                  if (currentIndex > 0) {
                    goToPreviousEmail()
                  }
                }}
              >
                <img src={prevIcon} alt='' className='inbox-prev-next-logo' />
              </div>
              <div
                className={`btn btn-sm btn-icon btn-light btn-active-light-primary me-2 ${
                  currentIndex === emails.length - 1 ? 'disabled-button' : ''
                }`}
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                title='Next message'
                onClick={() => {
                  if (currentIndex < emails.length - 1) {
                    goToNextEmail()
                  }
                }}
              >
                <img src={nextIcon} alt='' className='inbox-prev-next-logo' />
              </div>
              <div>
                <div
                  className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-250px py-4'
                  data-kt-menu='true'
                >
                  <div className='menu-item px-3'>
                    <div className='menu-link px-3'>
                      <i className='ki-duotone ki-element-11 fs-3 me-3'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                        <span className='path4'></span>
                      </i>
                      {formatMessage({id: 'New Group'})}
                    </div>
                  </div>
                  <div className='menu-item px-3'>
                    <div className='menu-link px-3'>
                      <i className='ki-duotone ki-badge fs-3 me-3'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                        <span className='path4'></span>
                        <span className='path5'></span>
                      </i>
                      {formatMessage({id: 'Contacts'})}
                    </div>
                  </div>
                  <div className='menu-item px-3'>
                    <div className='menu-link px-3'>
                      <i className='ki-duotone ki-people fs-3 me-3'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                        <span className='path3'></span>
                        <span className='path4'></span>
                        <span className='path5'></span>
                      </i>
                      {formatMessage({id: 'Groups'})}
                      <span className='badge badge-light-primary ms-auto'>
                        {formatMessage({id: 'new'})}
                      </span>
                    </div>
                  </div>
                  <div className='menu-item px-3'>
                    <div className='menu-link px-3'>
                      <i className='ki-duotone ki-element-2 fs-3 me-3'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      {formatMessage({id: 'Calls'})}
                    </div>
                  </div>
                  <div className='menu-item px-3'>
                    <div className='menu-link px-3'>
                      <i className='ki-duotone ki-setting-2 fs-3 me-3'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                      {formatMessage({id: 'Settings'})}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className='card-body'>
          {emailLoading ? (
            <div className='w-50 mb-5'>
              <Skeleton
                height={40}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          ) : (
            <div className='d-flex flex-wrap gap-2 justify-content-between mb-8'>
              {threadEmails && threadEmails.length > 0 && (
                <div className='d-flex align-items-center flex-wrap gap-2'>
                  <h2 className='fw-semibold me-3 my-1'>{threadEmails[0].subject}</h2>
                  <span className='badge badge-light-primary my-1 me-2'>
                    {formatMessage({id: 'inbox'})}
                  </span>
                  <span className='badge badge-light-danger my-1'>
                    {formatMessage({id: 'important'})}
                  </span>
                </div>
              )}
            </div>
          )}
          {emailLoading ? (
            <div className='d-flex w-100 gap-4 mb-4'>
              <div className='w-100'>
                <Skeleton
                  height={80}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          ) : (
            <div>
              {threadEmails &&
                threadEmails.map((email: any, index) => (
                  <div key={email.emailMessageId} data-kt-inbox-message='message_wrapper'>
                    <div
                      className='d-flex flex-wrap gap-2 flex-stack'
                      data-kt-inbox-message='header'
                    >
                      <div className='d-flex align-items-center mb-4'>
                        <div className='symbol symbol-50 me-4 bg-light-danger'>
                          <span
                            className='symbol-label text-danger'
                            // style={{
                            //   backgroundImage:
                            //     'url(https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500)',
                            // }}
                          >
                            {email && email.fromName
                              ? email.fromName.charAt(0).toUpperCase()
                              : email.fromEmail.charAt(0).toUpperCase()}
                          </span>
                        </div>
                        <div className='pe-5'>
                          <div
                            className='d-flex align-items-center flex-wrap gap-1 cursor-pointer'
                            onClick={() => handleEmailToggle(index)}
                          >
                            <div className='fw-bold text-gray-900'>
                              {' '}
                              {email.fromName ? email.fromName : email.fromEmail}
                            </div>
                            <span className='text-muted fw-bold ms-4'>
                              {formatTime(email?.createdAt)}
                            </span>
                          </div>
                          <div data-kt-inbox-message='details'>
                            <span className='text-muted fw-semibold'>
                              {formatMessage({id: 'to me'})}
                            </span>
                            <span
                              className='me-1 p-2 cursor-pointer'
                              onClick={() => {
                                setShowToMeMenu(!showToMeMenu)
                                setShowToMeEmail(email)
                              }}
                              data-kt-menu-trigger='click'
                              data-kt-menu-placement='bottom-start'
                            >
                              <img src={DropdownIcon} alt='' />
                            </span>

                            {showToMeMenu && email.emailMessageId === showToMeEmail.emailMessageId && (
                              <div
                                className='card h-120px shadow rounded kebab-menu-to-me-dropdown-adjustment ms-auto w-md-50'
                                onMouseLeave={() => setShowToMeMenu(false)}
                              >
                                <div className='px-4 py-3 dropdown-to-me-items-color'>
                                  <table className='table mb-0'>
                                    <tbody>
                                      <tr>
                                        <td className='w-75px text-muted'>From</td>
                                        <td>
                                          {showToMeEmail.fromName ? (
                                            <>
                                              {showToMeEmail.fromName} &lt;
                                              <a
                                                className='text-dark'
                                                href={`mailto:${showToMeEmail.fromEmail}`}
                                              >
                                                {showToMeEmail.fromEmail}
                                              </a>
                                              &gt;
                                            </>
                                          ) : (
                                            <a
                                              className='text-muted'
                                              href={`mailto:${showToMeEmail.fromEmail}`}
                                            >
                                              {showToMeEmail.fromEmail}
                                            </a>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className='text-muted'>Date</td>
                                        <td>
                                          {DateTime.fromISO(showToMeEmail.createdAt)
                                            .setZone('local')
                                            .setLocale('en')
                                            .toFormat('dd LLL yyyy, h:mm a')}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className='text-muted'>Subject</td>
                                        <td>{showToMeEmail.subject}</td>
                                      </tr>
                                      <tr>
                                        <td className='text-muted'>Reply-to</td>
                                        <td>
                                          {showToMeEmail && showToMeEmail.toEmail.length > 0 ? (
                                            <>
                                              {showToMeEmail.toEmail[0].name
                                                ? `${showToMeEmail.toEmail[0].name}<`
                                                : ''}
                                              <a
                                                className='text-dark'
                                                href={`mailto:${showToMeEmail.toEmail[0].email}`}
                                              >
                                                {showToMeEmail.toEmail[0].name
                                                  ? `${showToMeEmail.toEmail[0].email}`
                                                  : showToMeEmail.toEmail[0].email}
                                              </a>
                                              {showToMeEmail.toEmail[0].name ? `>` : ''}
                                            </>
                                          ) : (
                                            ''
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='d-flex align-items-center flex-wrap gap-2'>
                        <span className='fw-semibold text-muted text-end me-3'>
                          {email.time} {/* Assuming each email has a time */}
                        </span>
                        <div className='d-flex'>
                          <div
                            className='btn btn-sm btn-icon btn-clear btn-active-light-primary'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            title='star'
                          >
                            <button
                              className='btn m-0 p-1 d-block bg-light'
                              onClick={() => markedStar(email.emailMessageId)}
                            >
                              <img
                                src={
                                  starredEmails[email.emailMessageId] ? starActiveIcon : starIcon
                                }
                                alt={email.liked ? 'Checkmark Active' : 'Checkmark'}
                                className='like'
                              />
                            </button>
                          </div>
                          <div className='position-relative align-self-center'>
                            <div
                              className='p-2 cursor-pointer bg-light rounded-2 d-flex justify-content-center align-items-center'
                              onClick={() => {
                                setShowKebabMenu(!showKebabMenu)
                                setShowEmail(email)
                              }}
                            >
                              <img src={threeDots} alt='' width={15} height={15} />
                            </div>
                            {showKebabMenu && email.emailMessageId === showEmail.emailMessageId && (
                              <div
                                className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                                style={{top: '40px', right: 0}}
                                ref={dropdownRef}
                              >
                                <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100'>
                                  <button
                                    type='button'
                                    className='m-0 border-0 bg-transparent text-dark font-size-12 bg-hover-muted'
                                    onClick={() => {
                                      setIsForwardEmailClick(true)
                                      console.log(showEmail, ' email')
                                    }}
                                  >
                                    {formatMessage({id: 'Forward'})}
                                  </button>
                                </div>
                                <div className=' border-gray-300 border-0 p-2 dropdown-items w-100'>
                                  <button
                                    type='button'
                                    className='m-0 border-0 bg-transparent text-dark font-size-12 bg-hover-muted'
                                    onClick={() => {
                                      setIsForwardEmailClick(false)
                                      console.log(showEmail, ' email')
                                    }}
                                  >
                                    {formatMessage({id: 'Reply'})}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`collapsible-content ${expandedIndex === index ? 'expanded' : ''}`}
                      ref={(el) => (contentRefs.current[index] = el)}
                      style={{
                        maxHeight: expandedIndex === index ? 'none' : '0px',
                      }}
                      data-kt-inbox-message='message'
                    >
                      <InboxQuill
                        quillText={quillText}
                        setQuillText={setQuillText}
                        templateData={email}
                        isDisable={true}
                      />
                      {email.sharedInboxAttachments &&
                        email.sharedInboxAttachments.length > 0 && (
                          <div>
                            <h1 className='attachment-header'>
                              {formatMessage({id: 'Attachments'})}
                            </h1>
                            <div className='d-flex gap-4'>
                              {email.sharedInboxAttachments.map(
                                (attachment: any, index: number) => (
                                  <div key={index}>
                                    <Attachments
                                      key={attachment.sharedInboxAttachmentId}
                                      image={
                                        attachment.file.name &&
                                        attachment.file.name.includes('.') &&
                                        attachment.file.name.split('.').pop()?.toLowerCase() ===
                                          'pdf'
                                          ? Pdf
                                          : Doc
                                      }
                                      attachmentName={attachment.file.name.split('/').pop()}
                                      fileName={attachment.file.name}
                                    />
                                  </div>
                                )
                              )}
                            </div>
                            <div className='separator my-6'></div>
                          </div>
                        )}{' '}
                    </div>
                    {threadEmails && index < threadEmails.length - 1 && (
                      <div className='separator my-6'></div>
                    )}
                  </div>
                ))}
            </div>
          )}

          {/*
                        <!--end::Message accordion-->*/}
          {/* <div className='separator my-6'></div> */}
          {threadEmails && threadEmails.length > 0 && emailStatus.toLowerCase() !== 'trash' && (
            <Formik
              validationSchema={composeEmailSchema}
              initialValues={initialValues}
              onSubmit={submitStep}
            >
              {(formik) => {
                return (
                  <Form id='kt_inbox_reply_form' className='rounded border'>
                    {' '}
                    <EmailForm
                      userInfo={userInfo}
                      setEmailStatus={setEmailStatus}
                      formik={formik}
                      providerEmailId={
                        threadEmails && threadEmails[threadEmails.length - 1].providerEmailId
                      }
                      subject={threadEmails && threadEmails[threadEmails.length - 1].subject}
                      lastEmail={threadEmails && threadEmails[0]}
                      emailLoading={emailLoading}
                      setShowEmail={setShowEmail}
                      showEmail={showEmail}
                      isForwardEmailClick={isForwardEmailClick}
                      setIsForwardEmailClick={setIsForwardEmailClick}
                      providerThreadId={
                        threadEmails && threadEmails[threadEmails.length - 1].providerThreadId
                      }
                    />
                  </Form>
                )
              }}
            </Formik>
          )}
        </div>
      </div>
      <ConfirmationModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        deleteMails={deleteMails}
        isDeleting={isDeleting}
      />
    </>
  )
}
